<template>
  <div style="padding: 20px;">
    <el-table
      :data="tableData.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase())).slice((currentPage - 1) * pageSize, currentPage * pageSize)"
      stripe>
      <el-table-column
        label="商场名称"
        prop="name">
      </el-table-column>
      <el-table-column
        label="分组"
        prop="group">
      </el-table-column>
      <el-table-column
        label="场ID"
        prop="place_id">
      </el-table-column>
      <el-table-column
        label="导航类型"
        :formatter="formatType"
        prop="type">
      </el-table-column>
      <el-table-column
        label="G2停车场"
        :formatter="(_,  __, value) => value === 0 ? '否' : '是'"
        prop="is_g2">
      </el-table-column>
      <el-table-column
        label="环境"
        :formatter="formatEnv"
        prop="env">
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="create_time">
      </el-table-column>
      <el-table-column
        width="500"
        align="right">
        <template slot="header" slot-scope="scope">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-input v-model="search" size="mini" placeholder="输入关键字搜索"/>
            </el-col>
            <el-col :span="12">
              <el-button
                size="mini"
                type="success"
                @click="handleCreate();dialogFormVisible = true">新增
              </el-button>
              <el-button type="primary" size="mini" @click="navigatorAndPosition(scope)">导航和定位更新</el-button>
            </el-col>
          </el-row>
        </template>
        <template slot-scope="scope">

          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row);dialogFormVisible = true">编辑
          </el-button>
          <el-button
            size="mini"
            type="warning"
            style="margin-left: 0px"
            @click="handleConfig(scope.$index, scope.row);dialogConfFormVisible = true">配置
          </el-button>
          <el-button
            size="mini"
            type="primary"
            style="margin-left: 0px"
            @click="handleDeploy(scope.$index, scope.row);dialogPubFormVisible = true">发布
          </el-button>
          <el-dropdown>
            <el-button type="info" size="mini">
              更多<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native='handleInfo(scope.row, "rancher")'>服务rancher</el-dropdown-item>
              <el-dropdown-item @click.native='handleInfo(scope.row, "list")'>接口list</el-dropdown-item>
              <el-dropdown-item @click.native='handleInfo(scope.row, "deploy")'>部署后台</el-dropdown-item>
              <el-dropdown-item @click.native='handleInfo(scope.row, "road")'>路网标注</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="total"
      :page-size="15"
      @current-change="currentChange">
    </el-pagination>
    <el-dialog title="编辑"
               :visible.sync="dialogFormVisible"
               width="60%"
               v-loading="loading">
      <el-form :model="form" :inline="true">
        <el-form-item label="商场名称">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="分组">
          <el-input v-model="form.group" autocomplete="off" :disabled=isDisabled></el-input>
        </el-form-item>
        <el-form-item label="场ID">
          <el-input v-model="form.place_id" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="导航类型">
          <el-select v-model="form.type" :disabled=isDisabled placeholder="类型">
            <el-option
              v-for="item in typeData"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="环境">
          <el-select v-model="form.env" :disabled=isDisabled placeholder="环境">
            <el-option
              v-for="item in envData"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否是G2停车场">
          <el-radio-group v-model="form.is_g2">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="handleModify()">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="发布"
               :visible.sync="dialogPubFormVisible"
               width="70%"
               v-loading="loading">
      <div slot="title" class="header-title">
        <span class="name">{{ pubName }}</span>
      </div>
      <el-table :data="paramData" stripe="stripe" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="floor" label="楼层" width="95"></el-table-column>
        <el-table-column prop="distance_coming" label="即将到达">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.distance_coming"
                             :min="1"
                             :max="99"
                             size="small"
                             controls-position="right"/>
          </template>
        </el-table-column>
        <el-table-column prop="distance_arrival" label="到达目的地">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.distance_arrival"
                             :min="1"
                             :max="99"
                             size="small"
                             controls-position="right"/>
          </template>
        </el-table-column>
        <el-table-column prop="reset_distance" label="重新规划(距离)">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.reset_distance"
                             :min="1"
                             :max="99"
                             size="small"
                             controls-position="right"/>
          </template>
        </el-table-column>
        <el-table-column prop="reset_count" label="重新规划(次数)">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.reset_count"
                             :min="1"
                             :max="99"
                             size="small"
                             controls-position="right"/>
          </template>
        </el-table-column>
        <el-table-column prop="view_scale" label="地图缩放系数">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.view_scale"
                             :min="0"
                             :max="99"
                             size="small"
                             controls-position="right"/>
          </template>
        </el-table-column>
        <el-table-column prop="view_scale" label="ar_id">
          <template slot-scope="scope">
            <el-input v-model="scope.row.ar_id" size="small" controls-position="right"/>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <div>
          <el-switch
            v-model="deploy_ar"
            active-color="#13ce66"
            inactive-color="grey">
          </el-switch>
          <span style="vertical-align: text-top">同时部署定位服务</span>
        </div>
        <div>
          <el-switch
            v-model="deployG2"
            active-color="#13ce66"
            inactive-color="grey">
          </el-switch>
          <span style="vertical-align: text-top">同时部署G2</span>
        </div>
        <div>
          <el-button size="small" @click="closePubDialog()">取消</el-button>
          <el-button size="small" type="primary" @click="handlePub()">发布</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="配置"
               :visible.sync="dialogConfFormVisible"
               width="60%"
               v-loading="loading"
               center>
      <div slot="title" class="header-title">
        <span class="name">{{ confName }}</span>
      </div>
      <el-button type="success"
                 @click="addConfigRow"
                 size="small"
                 plain
                 style="text-align:left;margin-left:10px">添加</el-button>
      <el-table :data="configData" stripe="stripe">
        <el-table-column prop="key" label="Key">
          <template slot-scope="scope">
            <el-input v-model="scope.row.key" size="small"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="value" label="Value">
          <template slot-scope="scope">
            <el-input v-model="scope.row.value" size="small"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="comment" label="说明">
          <template slot-scope="scope">
            <el-input v-model="scope.row.comment" size="small"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="130">
          <template slot-scope="scope">
            <el-button @click.native.prevent="deleteConfigRow(scope.$index, scope.row)"
                       type="danger"
                       size=small
                       plain>删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align:right">
        <el-button @click="dialogConfFormVisible = false">取消</el-button>
        <el-button type="primary" @click="handleConfSave()">保存</el-button>
      </div>
    </el-dialog>
    <deploy-dialog :visible="visible" @closeNavAndPos="closeNavAndPos"/>
  </div>
</template>

<script>
import DeployDialog from './deployDialog.vue';
import {
  deployNavigationData,
  deployService,
  getDeployList, jenkinsHealth,
  modifyDeploy,
  refreshConfig,
  refreshParam, saveConfig, saveParam,
  deployParkingSpace,
} from '@/api/deploy';

export default {
  components: {
    DeployDialog,
  },
  data() {
    return {
      tableData: [],
      search: '',
      typeData: [
        { value: '7', label: 'VR' },
        { value: '11', label: 'AR' },
        { value: '121', label: '模拟' },
      ],
      envData: [
        { value: '', label: '线上' },
        { value: 'test', label: '测试' },
        { value: 'test1', label: '测试1' },
        { value: 'test2', label: '测试2' },
        { value: 'test3', label: '测试3' },
      ],
      paramData: [],
      total: 0,
      pageSize: 15,
      currentPage: 1,
      dialogFormVisible: false,
      dialogPubFormVisible: false,
      dialogConfFormVisible: false,
      form: {},
      formLabelWidth: '80px',
      multipleSelection: [],
      pubId: null,
      pubInfo: {},
      pubName: '发布',
      loading: false,
      distType: '0',
      isDisabled: true,
      confName: '配置',
      confId: null,
      configData: [],
      visible: false,
      deploy_ar: false,
      deployG2: false,
    };
  },
  mounted() {
    this.refreshTable();
  },
  methods: {
    closePubDialog() {
      this.dialogPubFormVisible = false;
      this.deploy_ar = false;
    },
    /**
     * 导航服务和定位更新
     */
    navigatorAndPosition(scope) {
      console.log('scope', scope);
      this.visible = true;
    },
    closeNavAndPos() {
      this.visible = false;
    },
    handleEdit(index, row) {
      console.log(index, row);
      this.form = JSON.parse(JSON.stringify(row));
      this.isDisabled = true;
    },
    handleDeploy(index, row) {
      console.log(index, row);
      this.pubId = row.id;
      this.pubName = row.name;
      this.pubInfo = row;
      this.deployG2 = row.is_g2 === 1;
      this.multipleSelection = [];
      this.refreshParam(row.id);
    },
    handleConfig(index, row) {
      this.confName = row.name;
      this.confId = row.id;
      this.confInfo = row;
      this.refreshConfig(row.id);
    },
    handleCreate() {
      this.form = {};
      this.isDisabled = false;
    },
    formatType(row) {
      for (let i = 0; i < this.typeData.length; i++) {
        if (this.typeData[i].value === row.type) {
          return this.typeData[i].label;
        }
      }
      return row.type;
    },
    formatEnv(row) {
      for (let i = 0; i < this.envData.length; i++) {
        if (this.envData[i].value === row.env) {
          return this.envData[i].label;
        }
      }
      return row.env;
    },
    currentChange(currentPage) {
      this.currentPage = currentPage;
    },
    addConfigRow() {
      this.configData = [{}, ...this.configData];
    },
    deleteConfigRow(index) {
      this.configData.splice(index, 1);
    },
    async handleModify() {
      if (await this.checkInner() === false) {
        return false;
      }
      if (Number.isNaN(this.form.place_id)) {
        this.$message.error('场ID不是数字');
        return false;
      }
      if (this.form.type === undefined) {
        this.$message.error('请选择导航类型');
        return false;
      }
      if (this.form.env === undefined) {
        this.$message.error('请选择环境');
        return false;
      }
      if (!this.form.name || !this.form.group) {
        this.$message.error('请填写完整');
        return false;
      }
      if (this.form.group && this.form.group !== this.form.group.toUpperCase()) {
        this.$message.error('分组group需要全部大写');
        return false;
      }
      this.loading = true;
      this.form.place_id = +this.form.place_id;
      this.form.group = this.form.group.trim();
      this.form.is_g2 = this.form.is_g2 || 0;
      console.log(this.form);
      modifyDeploy(this.form).then((response) => {
        if (!this.form.id) {
          this.$message.success('添加成功');
          let groupEnv;
          const group = this.form.group.toLowerCase();
          const groupMidline = group.replaceAll('_', '-');
          if (this.form.env && this.form.env !== '') {
            groupEnv = `${group}_${this.form.env}`;
          } else {
            groupEnv = group;
          }
          const groupEnvMidline = groupEnv.replaceAll('_', '-');
          deployService({
            token: 'NAV_DEPLOY',
            GROUP: group,
            GROUP_MIDLINE: groupMidline,
            GROUP_ENV: groupEnv,
            GROUP_ENV_MIDLINE: groupEnvMidline,
            ENV: this.form.env,
            TYPE: this.form.type,
          }).then(() => {
            this.$message.success('Jenkins部署');
          }).catch((error) => {
            this.$message.error(`部署失败, ${error}`);
          });
        } else {
          this.$message.success('更新成功');
        }
        this.refreshTable();
        this.dialogFormVisible = false;
      }).catch((error) => {
        console.log(error);
        this.$message.error(`更新失败, ${error}`);
      });
      this.loading = false;
      return undefined;
    },
    refreshTable() {
      getDeployList().then((data) => {
        this.tableData = data;
        this.total = data.length;
      });
    },
    refreshParam(id) {
      refreshParam(id).then((data) => {
        this.paramData = data;
      });
    },
    refreshConfig(id) {
      refreshConfig(id).then((data) => {
        this.configData = data;
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    async handlePub() {
      if (await this.checkInner() === false) {
        return false;
      }
      console.log(this.multipleSelection);
      if (this.multipleSelection.length === 0) {
        this.$message.warning('没有选择楼层');
        return false;
      }
      this.distType = '0';
      if (this.multipleSelection.length === this.paramData.length) {
        this.distType = '1';
      }
      this.loading = true;
      const params = {
        floors: this.multipleSelection,
        deploy_ar: this.deploy_ar,
        is_g2: this.deployG2,
      };
      console.log('this.multipleSelection', this.multipleSelection);
      console.log('params', params);
      console.log('params', JSON.stringify(params));
      saveParam(this.pubId, this.multipleSelection).then(() => {
        this.$message.success('配置保存成功');
        let groupEnv;
        const group = this.pubInfo.group.toLowerCase();
        if (this.pubInfo.env && this.pubInfo.env !== '') {
          groupEnv = `${group}_${this.pubInfo.env}`;
        } else {
          groupEnv = group;
        }
        const objStr = JSON.stringify(params);
        const objBase64 = Buffer.from(objStr).toString('base64');
        this.deploy_ar = false;
        deployNavigationData({
          token: 'NAV_DEPLOY',
          GROUP: group,
          PLACE_ID: this.pubInfo.place_id,
          ENV: this.pubInfo.env,
          GROUP_ENV: groupEnv,
          DIST_TYPE: this.distType,
          CONFIG: objBase64,
        }).then(() => {
          this.$message.success('Jenkins发布');
          deployParkingSpace({
            place_id: this.pubInfo.place_id,
            floor: this.multipleSelection.map(item => item.floor).join(','),
            env: this.pubInfo.env,
          }).then(() => {
            this.$message.success('车位号发布成功');
          }).catch(() => {
            this.$message.error('车位号发布失败；请重新发布');
          });
        }).catch((error) => {
          this.$message.error(`发布失败, ${error}`);
          this.deploy_ar = false;
        });
        this.dialogPubFormVisible = false;
      }).catch((error) => {
        console.log(error);
        this.$message.error(`配置保存失败, ${error}`);
      });
      this.loading = false;
      this.deploy_ar = false;
      return undefined;
    },
    async checkInner() {
      this.health = false;
      this.loading = true;
      await jenkinsHealth().then(() => {
        this.$message.success('Jenkins网络连接正常');
        this.health = true;
      }).catch((error) => {
        console.log(error);
        this.$message.error(`Jenkins网络连接失败, ${error}`);
        this.health = false;
      });
      this.loading = false;
      return this.health;
    },
    handleInfo(row, command) {
      let groupEnv;
      const group = row.group.toLowerCase();
      if (row.env && row.env !== '') {
        groupEnv = `${group}_${row.env}`;
      } else {
        groupEnv = group;
      }
      const groupEnvMidline = groupEnv.replaceAll('_', '-');

      let url;
      if (command === 'rancher') {
        url = `https://ali-rancher.aibee.cn/p/c-86hlp:p-xmck4/workload/deployment:robot:robot-vr-navigation-${groupEnvMidline}`;
      } else if (command === 'list') {
        url = `https://vrnav.aibee.cn/locate/mini/list?group=${row.group}&env=${row.env}`;
      } else if (command === 'deploy') {
        url = `https://deploy.aibee.cn/#/place/add?id=${row.place_id}`;
      } else if (command === 'road') {
        url = `https://deploy.aibee.cn/#/map/newMapRouter?place_id=${row.place_id}`;
      } else {
        return;
      }

      console.log(url);
      window.open(url, '_blank');
    },
    async handleConfSave() {
      console.log(this.configData);
      this.loading = true;
      saveConfig(this.confId, this.confInfo.group, this.configData).then(() => {
        this.$message.success('配置保存成功');
        this.dialogConfFormVisible = false;
      }).catch((error) => {
        console.log(error);
        this.$message.error(`配置保存失败, ${error}`);
      });
      this.loading = false;
    },
  },
};
</script>
<style scoped>
.dialog-footer{
  display: flex;
  padding-top: 10px;
  justify-content: space-between;
}
</style>
